
let InteractiveInviteChestPreview = require("./InteractiveInviteChestPreview")
let ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
let PromptTip = require("clover/scene/component/homescene/PromptTip")
let UIProgressTimer = require("clover/panel/component/common/UIProgressTimer")

let [CommonRewardPanel] = require("clover/panel/CommonRewardPanel")

let logic = require("./InteractiveInviteLogic")
let {InteractiveInviteDataEvent} = require("./InteractiveInviteData")
const ShareUtil = require("../../../../utils/ShareUtil")

let InteractiveInvitePanel = xClass("InteractiveInvitePanel", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/panel_grant_panel_grant.csb")
})

const DATA_LISTENER_TAG = "interactiveInvitePanel"
let openDataPanelHeight = 520
let resList = [
    "packed/InteractiveInviteRes.pack",
    "cocos/one_step_btn_start.csb",
]
// "font/zzgftongxin_40_brownstroke.png",
// "font/zzgftongxin_40_brownstroke.fnt"
InteractiveInvitePanel.preloadRes = function () {
    return preloadWithLoadingPromise(resList, true);
}

InteractiveInvitePanel.prototype.init = function (data, config) {
    let self = this;
    BasePanel.prototype.init.call(self);

    self.data = data;
    self.config = config;

    this.oldFriendInteraction = AuthorizeMgr.isAuthorizeByScope("FriendInteraction")
    if (!AuthorizeMgr.isAuthorizeByScope("FriendInteraction")){
        self.initTipUI(); 
    }else{
        self.initUI(); 
        self.activeOpenContext();
    }
    self.addOnShow()
    // 更新Timer，每帧调用
    self.updateTimer = null;

    // 添加监听函数
    self.data.on(InteractiveInviteDataEvent.ProgressChange, ()=> self.onProgressChange(), DATA_LISTENER_TAG);
    self.data.on(InteractiveInviteDataEvent.CanGetChange, ()=> self.onCanGetChanged(), DATA_LISTENER_TAG);    
    self.data.on(InteractiveInviteDataEvent.CountChange, ()=> self.onCountChange(), DATA_LISTENER_TAG);    
    self.data.on(InteractiveInviteDataEvent.CDChange, ()=> self.onCDChange(), DATA_LISTENER_TAG);   

    const Event = require("hecore/EventDispatcher").Event;
    GlobalEventDispatcher.getInstance().dispatchEvent(Event.new(kGlobalEvents.kWelfareCenterPanel,
        {
            id: WelfareCenterId.freeGift,
        }))
}
// InteractiveInvitePanel.prototype.onShowCb = function () {
//     let self = this;
//     let doFunction = ()=>{
//         cc.log("InteractiveInvitePanel mini.onShow",AuthorizeMgr.isAuthorizeByScope("FriendInteraction"))
//         cc.log("InteractiveInvitePanel mini.onShow self.oldFriendInteraction",self.oldFriendInteraction)   
//         if (!AuthorizeMgr.isAuthorizeByScope("FriendInteraction") && self.oldFriendInteraction != AuthorizeMgr.isAuthorizeByScope("FriendInteraction")){
//             // self.onClose()
//             // // 校验授权
//             // let logic = require("./InteractiveInviteLogic")
//             // logic.openMain(()=> {
    
//             // }, (evt)=> { 
    
//             // }, ()=> {
    
//             // }); 
//             Toast.make("授权缺失")
//         }
//     }

//     AuthorizeMgr.checkAuthorizeByScope("FriendInteraction",doFunction,doFunction)

// }
InteractiveInvitePanel.prototype.addOnShow = function () {
    let self = this;
    if (window.mini) {
        self.onShowCb = ()=>{
            let doFunction = ()=>{
                cc.log("InteractiveInvitePanel mini.onShow",AuthorizeMgr.isAuthorizeByScope("FriendInteraction"))
                cc.log("InteractiveInvitePanel mini.onShow self.oldFriendInteraction",self.oldFriendInteraction)   
                if (!AuthorizeMgr.isAuthorizeByScope("FriendInteraction") && self.oldFriendInteraction != AuthorizeMgr.isAuthorizeByScope("FriendInteraction")){
                    self.oldFriendInteraction = AuthorizeMgr.isAuthorizeByScope("FriendInteraction")
                    // Toast.make("授权缺失")
                    self.onClose()
                    // 校验授权
                    let logic = require("./InteractiveInviteLogic")
                    logic.openMain(()=> {
            
                    }, (evt)=> { 
            
                    }, ()=> {
            
                    }); 
                }
            }
        
            AuthorizeMgr.checkAuthorizeByScope("FriendInteraction",doFunction,doFunction)
        }
        mini.onShow(self.onShowCb)
    }
}
InteractiveInvitePanel.prototype.removeOnShow = function () {
    let self = this;
    if (window.mini) {
        mini.offShow(self.onShowCb)
    }

}
InteractiveInvitePanel.prototype.initTipUI = function() {
    let self = this;
    // self.btn_orange_permission = self.getChildByName("btn_orange_permission");
    self.tipTxtLabel = self.getChildByName("txt");
    self.tipImg = self.getChildByName("img");

    self.getChildByName("btn_green_get").setVisible(false)
    self.getChildByName("txt_cd").setVisible(false)
    self.getChildByName("bubblebox_reward").setVisible(false)
    self.getChildByName("gift_get_text").setVisible(false)

    // quickBuildBtn(this.btn_orange_permission, UIGroupButton, PushBounceAnim, () => {
    //     cc.log("点击此处查看更多好友数据")
    
    // }, true);
    self.btn_orange_permission = UIButton.create(self.getChildByName("btn_orange_permission"), true)
    ButtonPushBounceAnim.create(self.btn_orange_permission)
    self.btn_orange_permission.on(UIButtonEvent.Click, function () {
        let doFunction = ()=>{
            self.onClose()
            // 校验授权
            let logic = require("./InteractiveInviteLogic")
            logic.openMain(()=> {

            }, (evt)=> { 

            }, ()=> {

            });    
        }
        let failFunction = ()=>{
            cc.log("授权失败")
            Toast.make(getText("授权失败"));
        }
        AuthorizeMgr.showAuthorizeGuidePanel(()=>{
            AuthorizeMgr.openSetting("FriendInteraction",doFunction,failFunction)
        },()=>{
            Toast.make(getText("授权失败"));
        })
        
    })
    self.btn_orange_permission.getChildByName("label").x = -50

        // 关闭按键
    self.btnClose = UIButton.create(self.getChildByName("btn_close"), true)
    ButtonPushBounceAnim.create(self.btnClose)
    self.btnClose.on(UIButtonEvent.Click, function () {
        self.onClose()
    })

}
InteractiveInvitePanel.prototype.initUI = function() {
    let self = this;
    self.getChildByName("btn_orange_permission").setVisible(false)
    self.getChildByName("img").setVisible(false)
    self.getChildByName("txt").setVisible(false)

    // 给子域绘图的地方
    self.inner = self.getChildByName("panel");

    // 标题栏下的提示文字
    let tipBelowTitle = self.getChildByName("txt1");
    tipBelowTitle.setFontStyle("bold");
    tipBelowTitle.setString(getText("interactive_main_desc"));

    // 领奖按键
    self.btnGet = UIGLabelButton.create(self.getChildByName("btn_green_get"), true)
    self.btnGet.setString(getText("interactive_main_btn"))
    self.btnGet.x += 130
    self.btnGet.setScaleX(0.93)
    self.btnGet.on(UIButtonEvent.Click, handler(self, self.onGetClick))
    ButtonPushBounceAnim.create(self.btnGet);

    // 分享按键
    self.btnShare = cc.CSLoader.createNode("cocos/one_step_btn_start.csb")
    self.btnShare = UIGLabelButton.create(self.btnShare)
    self.btnShare.getChildByName("reddot").removeFromParent(true);
    self.btnShare.getChildByName("num").removeFromParent(true);
    self.addChild(self.btnShare)
    self.btnShare.setScaleX(0.9)
    self.btnShare.setAnchorPoint(self.btnGet.getAnchorPoint())
    self.btnShare.x = self.btnGet.x - 260
    self.btnShare.y = self.btnGet.y + 9
    self.btnShare.setString(getText("interactive_main_null_btn"))
    self.btnShare.on(UIButtonEvent.Click, handler(self, self.onShareClick))
    ButtonPushBounceAnim.create(self.btnShare)

    // 关闭按键
    self.btnClose = UIButton.create(self.getChildByName("btn_close"), true)
    ButtonPushBounceAnim.create(self.btnClose)
    self.btnClose.on(UIButtonEvent.Click, function () {
        self.onClose()
    })

    // 进度条提示文本line1
    let tipProgress1 = self.getChildByName("txt2");
    tipProgress1.setString(getText("interactive_progress_desc_1"));    
    tipProgress1.setFontStyle("bold");

    // 进度条提示文本line2
    let tipProgress2 = self.getChildByName("txt3"); 
    tipProgress2.setFontStyle("bold");
    tipProgress2.setString(getText("interactive_progress_desc_2"));   
    tipProgress2.setContentSize(CalculateLbTTFSize(tipProgress2));

    // 进度文本
    self.progress = self.getChildByName("num")
    self.progress.setPosition(tipProgress2.x + tipProgress2.getContentSize().width + 6, tipProgress2.y + tipProgress2.getContentSize().height / 2 - 2);

    // 奖励气泡
    self.rewardBubble = self.getChildByName("bubblebox_reward");
    self.rewardBubble.setVisible(false);
    self.rewardBubble.x += self.rewardBubble.getContentSize().width / 2;

    // 进度礼包按键
    let gift = self.getChildByName("gift")
    self.giftAction = cc.CSLoader.createTimeline("cocos/panel_grant_gift1.csb");
    gift.runAction(self.giftAction)
    self.giftBtn = UIButton.create(gift.getChildByName("gift"), true)
    self.giftBtn.on(UIButtonEvent.Click, handler(self, self.onGetProgressClick))

    // 可领取文本
    self.gift_text = self.getChildByName("gift_get_text");
    self.gift_text.setVisible(false);
    self.textAction = cc.CSLoader.createTimeline("cocos/panel_grant_text.csb");
    self.gift_text.runAction(self.textAction)

    // 进度CD时间文本
    self.txtCD = self.getChildByName("txt_cd");
    self.txtCD.setVisible(false);
    self.txtCD.setPosition(self.txtCD.x + 7, self.txtCD.y);

    // 更新显示
    self.updateProgressCD();
    self.updateProgressValue();
    self.updateProgressReward();
    self.updateProgressRewardStatus();
    
    self.updateGetBtn();

    DCAssist.dc4ShareShow("interactive_invite");
}

InteractiveInvitePanel.prototype.onEnter = function() {
    let self = this;
    BasePanel.prototype.onEnter.call(self);

    self.progressTimer = UIProgressTimer.create(self.getChildByName("progress"));
    self.updateProgressValue();
}

InteractiveInvitePanel.prototype.updateGetBtn = function () {
    let self = this
    let canGet = self.data.canGet

    if (!self.btnGet)
        return;

    if (canGet > 0 && !self.btnGetPrompt) {
        // 为领取按键添加小红点
        let prompt = PromptTip.create();
        self.btnGet.addChild(prompt);
        let contentSize = self.btnGet.getContentSize();
        prompt.setPosition(contentSize.width / 2 - 12, contentSize.height / 2 - 14);

        self.btnGetPrompt = prompt;
    }

    if (self.btnGetPrompt) {
        self.btnGetPrompt.setNum(canGet);
    }

    const Event = require("hecore/EventDispatcher").Event;
    GlobalEventDispatcher.getInstance().dispatchEvent(Event.new(kGlobalEvents.kWelfareCenterAction,
        {
            id: WelfareCenterId.freeGift,
            redDot: !!canGet,
        }))
}

/**
 * 更新进度CD
 */
InteractiveInvitePanel.prototype.updateProgressCD = function() {
    let self = this;
    let cdInMillisec = self.data.getCDInMillisec();
    self.txtCD.setVisible(cdInMillisec > 0);
    self.refreshCD();
}

/**
 * 更新进度值
 * 进度值更新影响进度条以及礼包动画
 */
InteractiveInvitePanel.prototype.updateProgressValue = function(withAnimation) {
    let self = this;
    let data = self.data, config = self.config;

    if (self.progress) {
        self.progress.setString(`${data.progress}/${config.progress_limit}`);
    }

    if (self.progressTimer) {
        let toProgress = Math.min(data.progress / config.progress_limit, 1);
        self.progressTimer.setProgress(toProgress, (withAnimation && toProgress > self.progressTimer.progress)? 1: null);
    }
}

/**
 * 更新冷却时间文本
 */
InteractiveInvitePanel.prototype.refreshCD = function() {
    let self = this;
    if (!self.data || !self.txtCD || !self.txtCD.isVisible()) 
        return;

    let cdInMillisec = self.data.getCDInMillisec();
    if (cdInMillisec == 0) {
        self.txtCD.setVisible(false);
        return;
    }
    
    // 与上一次更新在300毫秒内不刷新
    if (self.txtCD._lastCdInMillisec && self.txtCD._lastCdInMillisec - cdInMillisec < 300) {
        return;
    }
        
    self.txtCD.setString(UIUtils.formatTime(cdInMillisec));
    self.txtCD._lastCdInMillisec = cdInMillisec;
}

/**
 * 更新进度奖励
 */
InteractiveInvitePanel.prototype.updateProgressReward = function() {
    let self = this
    
    let data = self.data, config = self.config
    let bubble_reward = config.extra_reward[Math.min(data.count, config.extra_reward.length - 1)];
    let item = [self.rewardBubble.getChildByName("icon1"), self.rewardBubble.getChildByName("icon2")];
    for (let i = 0; i < (bubble_reward.length > 2 ? 2 : bubble_reward.length); i++) {
        let num = item[i].getChildByName("num")
        let propMeta = MetaManager.getInstance().getPropMeta(bubble_reward[i].id)
        let icon = item[i].getChildByName("icon");
        if (propMeta && propMeta.expireTime !== 0) {
            propIcon = UIItemBuilder.createPropIcon(bubble_reward[i].id, (Localhost.time() + propMeta.expireTime))
            propIcon.x = icon.x
            propIcon.y = icon.y
            propIcon.setAnchorPoint(icon.getAnchorPoint())
            propIcon.setName(icon.getName())
            propIcon.setScale(icon.getScale())
            icon.removeFromParent(true)
            item[i].addChild(propIcon)
            num.setLocalZOrder(propIcon.getLocalZOrder() + 1)
            num.setString(bubble_reward[i].num);
        } else {
            icon.setSpriteFrame(UIItemBuilder.createPropIcon(bubble_reward[i].id).getSpriteFrame())
            if (icon.getChildByName("propBarTempProp")) {
                icon.getChildByName("propBarTempProp").removeFromParent(true);
            }
            num.setString(bubble_reward[i].num);
        }
    }
}

/**
 * 更新进度奖励可领取状态
 */
InteractiveInvitePanel.prototype.updateProgressRewardStatus = function() {
    let self = this
    let data = self.data, config = self.config;

    let available = data.progress >= config.progress_limit && data.getCDInMillisec() == 0
    let lastAvailable = self.gift_text.isVisible();
    if (available && !lastAvailable) {
        self.gift_text.setVisible(true);      
        self.giftAction.gotoFrameAndPlay(0, true);
        self.textAction.gotoFrameAndPlay(0, true);
    } else if (!available && lastAvailable) {
        self.gift_text.setVisible(false); 
        self.giftAction.gotoFrameAndPlay(0, 0, 0, false);
        self.textAction.gotoFrameAndPlay(0, 0, 0, false);
        if (self.preview) {
            self.preview.hide();
        }
    }
}

InteractiveInvitePanel.prototype.onEnterAnimFinish = function () {
    let self = this
    BasePanel.prototype.onEnterAnimFinish.call(self);
    if (!self.inner){
        return
    }

    let innerSize = self.inner.getContentSize()
    innerSize.height = openDataPanelHeight
    // 计算触摸事件坐标返回，转换为屏幕坐标（左上角为原点，单位为像素）
    let innerBgPos = self.inner.convertToWorldSpace()
    innerBgPos.y += 200;
    let wSize = cc.Director.getInstance().getWinSize()
    if (window.mini){
        let systemInfo = mini.getSystemInfoSync()
        let screenHeight = systemInfo.screenHeight
        let screenWidth = systemInfo.screenWidth
        // 最高的位置
        let minY = (1 - (innerBgPos.y + innerSize.height) / wSize.height) * screenHeight
        // 最低的位置
        let maxY = (1 - innerBgPos.y / wSize.height) * screenHeight
    
        let minX = innerBgPos.x / wSize.width * screenWidth
        let maxX = (innerBgPos.x + innerSize.width) / wSize.width * screenWidth
        OpenContextUtil.postMessage({
            command: "set touch",
            minX: minX,
            minY: minY,
            maxX: maxX,
            maxY: maxY
        });
        // 启动更新Timer
        self.updateTimer = self.getScheduler().scheduleScriptFunc(()=> {
            self.refresh();
        }, 0, false)
    }


}

/**
 * 点击领取按键
 */
InteractiveInvitePanel.prototype.onGetClick = function () {
    let self = this

    if (self.isBusy) {
        return;
    }

    self.isBusy = true;

    let resetBusy = ()=> self.isBusy = false;

    // 没有可领奖励提示
    if (!self.data.canGet) {
        Toast.make(getText("interactive_tip_nogift"), 1, resetBusy);
        return;        
    }

    let potentialOver = self.data.todayPotentialGot >= self.config.potential_gift_limit; // 今日领感兴趣礼物是否已达上限
    let existOver = self.data.todayExistGot >= self.config.exist_gift_limit; // 今日领同玩礼物是否已达上限
    // 可以领取到礼物
    if ((self.data.potentialCanGet > 0 && !potentialOver) || (self.data.existCanGet > 0 && !existOver)) {
        logic.getInteractiveGift()
        .then((rewards)=> {
            resetBusy();
            if (rewards)
                CommonRewardPanel.show(null, null, rewards);
        })
        .catch((evt)=> {
            resetBusy();
            Toast.make(curryQuickGetErrorText(evt.data));
        });
        return;
    }

    // 感兴趣礼物超限
    if (self.data.potentialCanGet > 0) {
        Toast.make(getText("interactive_tip_potential_limited"), 1, resetBusy);
        return;        
    }

    // 同玩礼物超限
    Toast.make(getText("interactive_tip_friendcloud_limited"), 1, resetBusy);
}

/**
 * 点击邀请按键
 */
InteractiveInvitePanel.prototype.onShareClick = function () {
    let self = this

    if (self.isBusy) {
        return;
    }
    self.isBusy = true;

    let resetBusy = ()=> self.isBusy = false;
    // 互动分享的分享组应该是读配置的，但是涉及到打点规范，还是写死"interactive_invite"，如果有更改需求直接更改分享组配置
    ShareUtil.clickInteractiveInvite(self.data.progress, resetBusy, resetBusy, resetBusy);
}

/**
 * 点击进度礼包
 */
InteractiveInvitePanel.prototype.onGetProgressClick = function () {
    let self = this

    if (self.isBusy) {
        return;
    }

    self.isBusy = true;

    let resetBusy = ()=> self.isBusy = false;
    
    // 进度不足，展示预览窗口
    if (self.data.progress < self.config.progress_limit) {
        resetBusy();        
        self.getOrCreatePreview().popup(3);
        return;
    }

    // CD未到，飘提示
    if (self.data.getCDInMillisec() > 0) {
        Toast.make(getText("interactive_tip_extrareward_cd"), 1, resetBusy);
        return;
    }

    // 领奖
    logic.getProgressReward()
    .then((rewards)=> {
        resetBusy();
        if (rewards) {
            CommonRewardPanel.show(getText("interactive_progress_grab_title"), null, rewards);
        }
    })
    .catch((evt)=> {
        resetBusy();  
        Toast.make(curryQuickGetErrorText(evt.data));
    });
}

InteractiveInvitePanel.prototype.playGetRewardAnim = function (rewardData) {
    let self = this

    if (rewardData) {
        if (rewardData.length == 1) {
            if (self.data.canGet == 0) {
                Toast.make(getText('interactive_tip_nogift'), 1, () => {
                })
            } else {
                Toast.make(getText('interactive_tip_total_limited'), 1, () => {
                })
            }
        } else {
            for (let i = 1; i < rewardData.length; i++) {
                self.createRewardAnim(i - 1, rewardData[i]);
            }
        }
    }
}

InteractiveInvitePanel.prototype.createRewardAnim = function (index, rewardData) {
    let self = this;

    let rewardTip = cc.CSLoader.createNode("cocos/panel_grant_tip_acquire.csb");
    rewardTip.getChildByName("icon").setSpriteFrame(UIItemBuilder.createPropIcon(rewardData.itemId).getSpriteFrame())
    rewardTip.getChildByName("num").setString(rewardData.num);
    self.addChild(rewardTip);
    rewardTip.x += 320;
    rewardTip.y -= 120;
    rewardTip.runAction(cc.Sequence.create(
        cc.FadeOut.create(0),
        cc.DelayTime.create(3 / 30 * index),
        cc.Spawn.create(
            cc.Sequence.create(
                cc.FadeIn.create(2 / 30),
                cc.DelayTime.create(13 / 30),
                cc.FadeOut.create(2 / 30)
            ),
            cc.MoveBy.create(15 / 30, cc.p(0, 400))
        ),
        cc.RemoveSelf.create(true)
    ))
}

InteractiveInvitePanel.prototype.activeOpenContext = function () {
    let self = this
    let config = self.config

    // 设置分享场景
    mini.setMessageToFriendQuery({
        shareMessageToFriendScene: ShareToFriendScene.InteractiveInvite
    });

    // 通知展示列表
    OpenContextUtil.postMessage({
        command: "interactive invite list",
        openid: META.user.openid,
        time: Localhost.time(), // 这个时间会用于当前用户判断是否可以删除互动发送云记录，使用服务器时间防止用户蓄意本地改时间清空数据
        config: JSON.stringify({
            list_limit: config.list_limit,
            potential_limit: config.potential_limit,
            exist_limit: config.exist_limit,
            list_priority: config.list_priority,
            no_friend_tip: getText("interactive_main_null_desc"),
            potential_share: config.potential_share,
            exist_share: config.exist_share
        })
    });

    // 设置子域展示
    self.innerBgSize = self.inner.getContentSize()
    self.innerBgSize.width -= 30
    let sharedCanvas = mini.getOpenDataContext().canvas
    sharedCanvas.width = self.innerBgSize.width
    sharedCanvas.height = openDataPanelHeight

    // 图片准备
    let imgs = ["interactive_bg", "interactive_send_exist", "interactive_send_potential", "interactive_talk_exist", "interactive_talk_potential", "interactive_sent"]
    imgs.forEach(name => {
        let fullPath = cc.loader.getFullUrl(getRealResourceName(`openData/${name}.png`));
        mini.downloadFile({
            url: fullPath,
            success: res => {
                OpenContextUtil.postMessage({
                    command: "update img",
                    name: name,
                    path: res.tempFilePath
                })
            }
        })
    });
}

/**
 * 每帧刷新
 */
InteractiveInvitePanel.prototype.refresh = function() {
    let self = this;

    if (self.isClosed)
        return;

    self.refreshCD();
    self.refreshCanvas();
}

/**
 * 刷新子域绘制
 */
InteractiveInvitePanel.prototype.refreshCanvas = function () {
    let self = this
    if (!self.rankSprite) {
        self.rankSprite = cc.Sprite.create()
        self.rankSprite.setContentSize(self.innerBgSize.width, openDataPanelHeight)
        self.rankSprite.setAnchorPoint(0, 0)
        self.rankSprite.setScale(cc.director.getContentScaleFactor())
        self.inner.addChild(self.rankSprite)
        self.rankSprite.y += 200;
    }

    let texture = self.rankSprite.getTexture()
    if (!texture) {
        texture = new cc.Texture2D()
        self.rankSprite.setTexture(texture)
        texture.initWithElement(mini.getOpenDataContext().canvas)
        texture.handleLoadedTexture()
        let rect = cc.rect(0, 0, texture.width, texture.height)
        self.rankSprite.setTextureRect(rect, false)
    } else {
        texture.updateTexture()
    }
}

/**
 * 获取预览面板
 */
InteractiveInvitePanel.prototype.getOrCreatePreview = function() {
    let self = this;
    if (!self.preview) {
        self.preview = InteractiveInviteChestPreview.create(self.rewardBubble);
    }
    return self.preview;
}

/**
 * 关闭
 */
InteractiveInvitePanel.prototype.onClose = function () {
    let self = this
    self.clearAll();
    OpenContextUtil.postMessage({
        command: "exit"
    })

    BasePanel.prototype.onClose.call(self);
}
InteractiveInvitePanel.prototype.onCleanup = function () {
    let self = this;
    self.clearAll();
    unloadResList(resList)
}

InteractiveInvitePanel.prototype.clearTimer = function () {
    let self = this;
    if (self.updateTimer != null) {
        self.getScheduler().unscheduleScriptEntry(self.updateTimer)
        self.updateTimer = null
    }
}

InteractiveInvitePanel.prototype.clearAll = function() {
    let self = this;

    if (self.progressTimer) {
        self.progressTimer.removeFromParent(true);
        self.progressTimer = null;
    }
    
    if (self.rankSprite) {
        self.rankSprite.removeFromParent(true);
        self.rankSprite = null;
    }

    if (self.preview) {
        self.preview.destroy();
        self.preview = null;
    }

    if (self.data) {
        self.data.removeEventListenersByTag(DATA_LISTENER_TAG);
        self.data = null;
    }

    self.config = null
    self.clearTimer();
    self.removeOnShow();
}

/**
 * 进度条更新
 */
InteractiveInvitePanel.prototype.onProgressChange = function () {
    let self = this
    self.updateProgressValue(true);
    self.updateProgressRewardStatus();
}

/**
 * 互动奖励领取数变更
 */
InteractiveInvitePanel.prototype.onCanGetChanged = function () {
    let self = this
    self.updateGetBtn();
}

/**
 * 领取进度奖励次数变更
 */
InteractiveInvitePanel.prototype.onCountChange = function () {
    let self = this
    self.updateProgressReward();
}

/**
 * 领取进度奖励时间戳变更
 */
InteractiveInvitePanel.prototype.onCDChange = function () {
    let self = this
    self.updateProgressCD();
    self.updateProgressRewardStatus();
}

module.exports = InteractiveInvitePanel